import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { UFooter, UFullPage, USection } from "../common/ui.page";
import { BoxCut } from "../components/wh.ui.cut";
import { GREY, WHITE } from "../style/theme";
import { UIcon } from "../common/ui.icon";
import { USkeletonList } from "../common/ui.skeletons";
import { ParallaxBox } from "../common/ui.parallax";
import { UButton, UListItemButton } from "../common/ui.buttons";
import { CPage, CPageTop } from "../components/cr.ui.page";
import { useRest } from "../common/rest";
import { groupByFunction } from "../common/util";
import { WCodexIcon } from "../components/wh.ui.icons";
import { createContext, useContext, useState } from "react";
import { useUser } from "../components/user";
import { usePlayer } from "../components/player";

const NewOrderContext = createContext()
export function PageNewOrder() {
    const user = usePlayer()
    const [list] = useRest('player/codex/list')
    const [codex, setCodex] = useState()

    return <NewOrderContext.Provider value={{ codex, setCodex }}>
        <CPage>
            <CPageTop codex={codex && codex.name} secondary="Creazione Ordine di Battaglia" primary="Selezione codex" />
            <Box sx={{ backgroundColor: GREY[100] }}>
                <USection>
                    {!list && <USkeletonList count={15} height={40} />}
                    {list && <CodexList list={list} />}
                </USection>
            </Box>
            <UFooter sx={{ backgroundColor: GREY[200] }}>
                <USection sx={{ paddingY: 2 }}>
                    <UButton
                        call={'player/codex/' + (codex && codex.id) + '/new'}
                        onCall={user.reload}
                        disabled={!codex}
                        variant="contained">Crea Ordine di Battaglia</UButton>
                </USection>
            </UFooter>
        </CPage>
    </NewOrderContext.Provider>

}

function CodexList(props) {
    const { list } = props;
    const codexGrouped = groupByFunction(list, c => c.group.join('/'))
    const groups = Object.keys(codexGrouped).sort()

    return <List>
        {groups.map(g => <CodexGroup key={g} name={g} list={codexGrouped[g]} />)}
    </List>

}

function CodexGroup(props) {
    const { list, name } = props;
    const { codex, setCodex } = useContext(NewOrderContext)

    return <>
        <ListItem>
            <ListItemText primaryTypographyProps={{ sx: { color: GREY[700] } }} primary={name} />
        </ListItem>
        {list.map(c => <UListItemButton
            onClick={() => setCodex(c)}
            selected={codex && codex.name === c.name}
            key={c.id}>
            <ListItemIcon>
                <WCodexIcon name={c.name} />
            </ListItemIcon>
            <ListItemText primary={c.name} />
        </UListItemButton>)}
    </>
}